import { render, staticRenderFns } from "./refund-list-user.vue?vue&type=template&id=6b6a2184&"
import script from "./refund-list-user.vue?vue&type=script&lang=js&"
export * from "./refund-list-user.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports